<ng-content select="[additionalContent]"></ng-content>

@for (item of getWalletList() | async; track item) {
  <div class="grid-item">
    <div
      (keydown.enter)="onClick(item)"
      (click)="onClick(item)"
      class="asset-tile card-interactive"
      data-placement="top"
      bp-tooltip="{{ getTooltip(item) | translate: [getTradableByWallet(item).getSymbol()] }}"
      position="top"
      [ngClass]="{ 'is-starred': item?.isDefault() }">
      <div class="asset-tile-container" [tabindex]="0">
        <div class="asset-tile-container-inner">
          <div class="asset-tile-top">
            @if (getTransactionCounter(item)) {
              <span class="asset-tile-pending bp-navbar-badge">
                <strong>{{ item?.getPendingTransactionCount() }}</strong>
              </span>
            }
            <div class="asset-tile-top-crypto-currency">
              <div class="asset-tile-currency-container">
                <img
                  class="image-size"
                  [src]="getTradableByWallet(item)?.getLogo()"
                  (error)="img.src = getTradableByWallet(item)?.getDefaultLogo()"
                  alt="{{ 'logo_alt_text' | translate }}"
                  #img />
              </div>
              <span title="{{ item?.getName() }}" class="asset-tile-name">{{ item?.getName() }}</span>
            </div>
            @if (showDepositQR(item)) {
              <div class="asset-tile-action-items">
                <span
                  class="iconBorder"
                  [routerLink]="['/wallet/' + item?.getId()]"
                  (click)="openWalletDetails($event, item?.getId())"
                  [tabIndex]="-1">
                  <span class="asset-tile-action-item mod-send bpi__icon-qr iconSquare"></span>
                </span>
              </div>
            }
          </div>
          <div class="asset-tile-amount">
            <div class="asset-tile-amount-crypto">
              <strong>
                {{
                getWalletSumFiat(item)
                | fiat_precision_symbol
                : {
                id: fiat?.getId(),
                currencies: [fiat],
                symbol: true,
                prefix: +getWalletSumFiat(item) < 0.01,
                isDust: true,
                tradableAmount: +item.getBalance()
              }
              }}
            </strong>
          </div>
          <div class="asset-tile-amount-fiat">
            @if (!isIndexItem(item)) {
              <span>
                {{
                item?.getBalance()
                | tradable_precision_symbol: { id: getTradableByWallet(item)?.getId() }
                }}
              </span>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
}
